module.exports = __webpack_public_path__ + "assets/img/account_settings_top_banner_sm-7fd1b3f3eae281852a9fd29a2581f4a2.png";